import { Reveal } from "./Reveal";
import { RotatingImage } from "./RotatingImage";

export default function PageHero({ overline, title, desc, image, images, imageAlt }) {
  const slides = images || (image ? [image] : null);

  return (
    <div className="relative overflow-hidden bg-surface2/60 pb-16 pt-40 sm:pb-20" data-testid={`pagehero-${overline.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className={`mx-auto grid max-w-7xl items-center gap-10 px-5 sm:px-8 ${slides ? "lg:grid-cols-2" : ""}`}>
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-brand">{overline}</p>
          <h1 className="mt-4 font-heading text-4xl font-extrabold leading-[1.08] tracking-tight text-slate-900 sm:text-5xl lg:text-6xl">
            {title}
          </h1>
          {desc && <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-600 sm:text-lg">{desc}</p>}
        </Reveal>
        {slides && (
          <Reveal delay={0.15}>
            <div className="relative aspect-[4/3] w-full overflow-hidden rounded-2xl border border-line shadow-xl shadow-slate-900/10">
              <RotatingImage images={slides} interval={5500} alt={imageAlt || title} className="absolute inset-0" />
            </div>
          </Reveal>
        )}
      </div>
    </div>
  );
}
